<template>
  <div class="justify-content-center p-3"  :style="'background:' + (this.background === undefined ? '#59ABE3': this.background)">
    <div class="text-center" style="color: #FFFFFF; font-size: 1.4em; font-weight: 300">
      {{ socialData.name }}
    </div>
    <div class="text-center" v-b-tooltip title="Last month's change" style="color: #FFFFFF; font-size: 2em; font-weight: 700">
      {{ monthlyTrend }}%
    </div>
    <div class="text-center">
    <div class="d-inline-block px-2" v-b-tooltip.bottom title="Average monthly change" style="color: #FFFFFF; font-size: 1.4em; font-weight: 300">
      {{ monthlyAverageTrend }}%
    </div>
    <div class="d-inline-block px-2" v-b-tooltip.bottom title="Yearly change rate" style="color: #FFFFFF; font-size: 1.4em; font-weight: 300">
      {{ annualTrend }}%
    </div>
  </div>
    <div class="text-center" style="color: #FFFFFF; font-size: 1.3em; font-weight: 300">
      {{ currentCount | commas }} total
    </div>
    <div class="d-flex justify-content-center" >
      <short-line :chart-data="chartData" :options="options" style="width: 90%; height: 100px" ></short-line>
    </div>
  </div>
</template>

<script>
import ShortLine from '../../../utils/ShortLine'
export default {
  name: '',
  props: ['socialData', 'background'],
  components: {ShortLine},
  computed: {
    chartData: function () {
      let labels = []
      let data = []
      this.socialData.stats.forEach((x) => {
        labels.push(x.x_axis_label)
        data.push(x.count)
      })
      return {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderColor: '#ffffff'
          }
        ]

      }
    },
    currentCount: function () {
      return this.socialData.stats[this.socialData.stats.length - 1].count
    },
    monthlyTrend: function () {
      const initial = this.socialData.stats[this.socialData.stats.length - 2].count
      const final = this.socialData.stats[this.socialData.stats.length - 1].count
      const percentChange = ((final - initial)/ initial) * 100
      return parseFloat(percentChange).toFixed(2)
    },
    annualTrend: function () {
      const quantity = this.socialData.stats.length
      const initial = this.socialData.stats[0].count
      const final = this.socialData.stats[quantity - 1].count
      const percentChange = ((final - initial)/ initial) * 100
      return parseFloat(percentChange).toFixed(1)
    },
    monthlyAverageTrend: function () {
      const quantity = this.socialData.stats.length
      const initial = this.socialData.stats[0].count
      const final = this.socialData.stats[quantity - 1].count
      const percentChange = (((final - initial)/ initial)/ quantity) * 100
      return parseFloat(percentChange).toFixed(1)
    }
  },
  data: function () {
    return {
      options: {
        aspectRatio: 1,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[0].data[tooltipItem.index]
              if (parseInt(value) >= 1000) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              } else {
                return value
              }
            }
          }
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false
            }
          }]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/charts/SocialMediaOverviewChart.vue